// Datos de contacto centralizados de Radixagro.
// Actualizar acá el número de WhatsApp una sola vez para todo el sitio.

export const WHATSAPP_NUMBER = '5492352602000'; // +54 9 2352 60-2000

export const CONTACT_EMAIL = 'nicovilao@gmail.com';

export const CONTACT_ADDRESS = 'Thames 122, Villa Adelina, Buenos Aires';

// Mensaje por defecto del botón flotante.
export const DEFAULT_WHATSAPP_MESSAGE =
	'Hola Radixagro, quisiera más información.';

// Construye el link de WhatsApp con un mensaje opcional prellenado.
export const buildWhatsappUrl = (message = DEFAULT_WHATSAPP_MESSAGE) =>
	`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

// Mensaje contextual del botón flotante según la sección/ruta actual.
export const whatsappMessageForPath = (pathname = '/') => {
	if (pathname.startsWith('/multiplic'))
		return 'Hola, quiero multiplicar mi semilla con Radixagro.';
	if (pathname.startsWith('/planta'))
		return 'Hola, quiero información sobre el servicio de clasificación de semillas.';
	if (pathname.startsWith('/productos'))
		return 'Hola, quiero información sobre los productos de Radixagro.';
	if (pathname.startsWith('/nosotros'))
		return 'Hola, quiero conocer más sobre Radixagro.';
	if (pathname.startsWith('/signup'))
		return 'Hola Radixagro, quisiera hacer una consulta.';
	return DEFAULT_WHATSAPP_MESSAGE;
};
